import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { defaultRegex } from 'src/app/shared/Regex/regex.constants';

export interface IafCalculatorData {
  revenueWithParent: any;
  totalRevenue: any;
}

@Component({
  selector: 'app-iaf-calculator-dialog',
  templateUrl: './iaf-calculator-dialog.component.html',
  styleUrls: ['./iaf-calculator-dialog.component.scss']
})
export class IafCalculatorDialogComponent {
  calculatedIafPercentage: number = 0;
  calculationPerformed: boolean = false;
  invalidInput1: boolean = false;
  invalidInput2: boolean = false;
  showIafError: boolean = false;
  required1: boolean = false;
  required2: boolean = false;
  IAFForm!: FormGroup;
  showRevenueWithParentError: boolean = false;
  showTotalRevenueError: boolean = false;
  invalidCalculation: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<IafCalculatorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IafCalculatorData,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.IAFForm = this.fb.group({
      revenueWithParent: ['', [Validators.required, this.positiveNumberValidator()]],
      totalRevenue: ['', [Validators.required, this.positiveNumberValidator()]]
    })
  }

  validateNumber(event: Event) {
    this.showIafError = false;
    const input = event.target as HTMLInputElement;
    let value = input.value;
    if (!defaultRegex['validDecimal'].test(value)) {
      input.value = '';
    }
    if (value.length > 15) {
      value = value.slice(0, 15);
      input.value = value;
    }
  }

  isFormValid(): boolean {
    const revenueWithParent = this.IAFForm?.get('revenueWithParent')?.value;
    const totalRevenue = this.IAFForm?.get('totalRevenue')?.value;

    return revenueWithParent != null && totalRevenue != null &&
      revenueWithParent.trim() !== '' && totalRevenue.trim() !== '';
  }


  getErrorMessage(controlName: string): string {
    const control = this.IAFForm.get(controlName);
    control?.markAsTouched({ onlySelf: true });
    if (control?.hasError('required')) {
      this.calculatedIafPercentage = 0;
      this.invalidCalculation = false;
      return controlName == 'revenueWithParent' ? 'Sales with this Corporate is required' : 'Your Total Sales is required';
    } else if (control?.hasError('invalidNumber')) {
      this.calculatedIafPercentage = 0;
      this.invalidCalculation = false;
      return 'Please enter the valid input';
    }
    return '';
  }


  positiveNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      return value != null && value <= 0 ? { 'invalidNumber': true } : null;
    };
  }

  calculateIAF(): void {
    this.showIafError = true;
    this.invalidCalculation = false;

    const revenueWithParent = this.IAFForm?.get('revenueWithParent')?.value;
    const totalRevenue = this.IAFForm?.get('totalRevenue')?.value;

    this.calculatedIafPercentage = (revenueWithParent / totalRevenue) * 100;
    if (this.calculatedIafPercentage > 100) {
      this.invalidCalculation = true;
    }
    else {
      this.calculationPerformed = true;
      this.invalidCalculation = false;
    }
  }


  applyCalculation(): void {
    if (this.calculationPerformed && this.calculatedIafPercentage != 0.00) {
      this.dialogRef.close({ calculatedIafPercentage: this.calculatedIafPercentage });
    } else {
      this.dialogRef.close();
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }


}
